<template>
  <div>
    <retailer v-if="isAdmin && !showSubRetailer" />
    <subRetailer v-else />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import retailer from "./components/retailer/index.vue";
import subRetailer from "./components/subretailer/index.vue";

export default {
  components: {
    retailer,
    subRetailer,
  },
  computed: {
    ...mapGetters({
        user: 'adminController/admin',
    }),
    ...mapState({
      showSubRetailer: (state) => state.retailerController.showSubRetailer,
    }),
    isAdmin() {
        return this.user.role == 'admin';
    },
  },
};
</script>

<style>
</style>